export default "__VITE_ASSET__08c6822d__"